import React from 'react';
import { useMediaList } from '#hooks/use-media-list.js';

export function useDocuments({ initialData, setUnsavedChanges }) {
    const [activeDocumentId, setActiveDocumentId] = React.useState(null);

    const onDeleteDocument = React.useCallback(
        (_, docId) => {
            if (activeDocumentId === docId) setActiveDocumentId(null);
        },
        [activeDocumentId]
    );

    const mediaList = useMediaList({
        initialData,
        setUnsavedChanges,
        onAdd: (_, media) => {
            setActiveDocumentId(media.id);
        },
        onDelete: onDeleteDocument
    });

    const isActive = React.useCallback((docId) => activeDocumentId === docId, [activeDocumentId]);

    const getActiveDocument = React.useCallback(
        () => mediaList.data?.find((doc) => doc.id === activeDocumentId) ?? null,
        [activeDocumentId, mediaList.data]
    );

    return {
        ...mediaList,
        isActive,
        setActiveDocument: setActiveDocumentId,
        getActiveDocument
    };
}
